var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#e58e1a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.67 16.246H7.6l-1.293-2.072-1.28 2.072H3l2.2-3.392-2.07-3.238h1.988l1.197 2.05 1.152-2.05h2.045l-2.1 3.38 2.259 3.25zM15.31 9c-.456-.042-.792-.42-.755-.85V4h.117l4.823 5H15.31zm6.417-.659l-5.785-6.004C15.735 2.122 15.449 2 15.15 2H7.713C6.228 1.983 5.01 3.102 4.992 4.5v2.33c0 .586.476 1.062 1.063 1.062s1.062-.476 1.062-1.063V4.5c.017-.292.283-.516.594-.5H12.43v4.15c-.036 1.534 1.25 2.806 2.88 2.85h4.557v8.5c-.016.292-.282.516-.592.5H7.713c-.311.017-.577-.206-.596-.499v-1.028c0-.587-.475-1.063-1.062-1.063-.587 0-1.063.476-1.063 1.063V19.5c.018 1.396 1.236 2.516 2.72 2.5h11.56c1.485.017 2.703-1.103 2.72-2.5V9c0-.246-.094-.482-.265-.659z",
    transform: "translate(-1495.000000, -188.000000) translate(1109.000000, 188.000000) translate(224.000000, 0.000000) translate(162.000000, -0.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.d689f07d17f4bbb4ede550196ea33d64.svg";
export { ForwardRef as ReactComponent };